export enum WorkBadgeReviewPolicySource {
  SHIFT_DISCOVERY = "SHIFT_DISCOVERY",
  SHIFT_DETAILS = "SHIFT_DETAILS",
}
